<script setup lang="ts">
import { ref } from 'vue'
import { useVersionStore } from '@/modules/version/stores/version.store'

import BaseModal from '@/shared/components/modal/BaseModal.vue'
import BodyModal from '@/shared/components/modal/BodyModal.vue'
import HeaderModal from '@/shared/components/modal/HeaderModal.vue'
import FooterModal from '@/shared/components/modal/FooterModal.vue'
import DefaultButton from '@/shared/components/button/DefaultButton.vue'
import TagItem from '@/shared/components/tag/TagItem.vue'

interface Props {
  title: string
}

defineProps<Props>()

const open = defineModel<boolean>('open', { required: true })
const versionStore = useVersionStore()

const mode = import.meta.env.MODE

const appVersion = ref<string>(__APP_VERSION__)

const onClose = (state: boolean): void => {
  open.value = state
}
</script>

<template>
  <BaseModal :open="open" class="max-w-sm" @close="onClose(false)">
    <HeaderModal :title="title" @close="onClose(false)" />
    <BodyModal>
      <div class="flex items-center justify-center py-4">
        <img src="@/assets/images/logo.png" class="h-26 w-26 mr-6" />
        <div class="text-black dark:text-white">
          <div class="font-medium text-2xl tracking-widest">
            <span class="dark:text-white">{{ $t('glossary.our') }}</span>
            <span class="text-primary">{{ $t('glossary.box', 2) }}</span>
          </div>
          <div class="font-bold text-sm py-1.5">
            {{ $t('glossary.version') }}:
            <span>{{ appVersion }}</span>
          </div>
          <div class="text-xs pt-1">
            {{ $t('glossary.build') }}:
            <span>{{ versionStore.buildId }}</span>
          </div>
          <div class="text-xs pt-1">
            {{ $t('glossary.buildNumber') }}:
            <span>{{ versionStore.buildNumber }}</span>
          </div>
        </div>
      </div>
      <div class="text-gray-700 text-center text-xs w-full pt-2 dark:text-white">
        <TagItem v-if="mode !== 'production'" :text="mode" class="capitalize" />
      </div>
    </BodyModal>
    <FooterModal class="justify-end">
      <DefaultButton :text="$t('common.close')" @click="onClose(false)" />
    </FooterModal>
  </BaseModal>
</template>
